import type { SVGProps } from "react";
const SvgFolder02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M11.57 21h-1.063c-4.01 0-6.015 0-7.261-1.546S2 15.42 2 10.444V7.22c0-1.917 0-2.876.324-3.595.23-.513.571-.936.984-1.223C3.888 2 4.661 2 6.206 2c.99 0 1.485 0 1.918.202.99.46 1.398 1.575 1.844 2.683l.539 1.337m-3.503 0h8.545c1.792 0 2.688 0 3.332.534.278.23.518.528.704.874.29.538.384 1.219.415 2.287"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M4.596 12.576c.43-1.15.647-1.724 1.067-2.085.68-.582 1.657-.485 2.494-.485h9.095c2.477 0 3.716 0 4.334.797 1.06 1.368-.191 3.587-.695 4.93-.904 2.408-1.356 3.612-2.256 4.346-1.371 1.119-3.366.904-5.021.904H9.937c-3.543 0-5.314 0-6.236-1.096-1.7-2.025.13-5.274.895-7.312Z"
    />
  </svg>
);
export default SvgFolder02;
